/** Draft Terms of Use (EN) — validate with counsel before relying on as final legal text. */
export const termsEn = {
  title: 'Terms of Use',
  lastUpdatedLabel: 'Last updated',
  lastUpdated: 'July 27, 2026',
  sections: [
    {
      heading: '1. Purpose',
      paragraphs: [
        'These Terms of Use (the “Terms”) govern access to and use of the Rentalyzer platform (the “Service”), available notably at app.rentalyzer.ca and related domains, operated by DMII / Rentalyzer (“we”, “us”, “our”).',
        'By creating an account or using the Service, you agree to be bound by these Terms. If you do not accept these Terms, you must not use the Service.',
      ],
    },
    {
      heading: '2. Description of the Service',
      paragraphs: [
        'Rentalyzer is a software tool for rental real-estate profitability analysis and deal management. It allows you to model properties, financing scenarios, generate reports, and share analyses with parties you choose.',
        'Certain features (for example for brokers or private lenders) may be announced, restricted, or rolled out progressively. Access to those modules may require approval or a separate commercial offer.',
      ],
    },
    {
      heading: '3. User account',
      paragraphs: [
        'You must provide accurate information when signing up and keep your credentials confidential. You are responsible for all activity under your account.',
        'You must be at least 18 years old and legally able to enter into a contract. If you use the Service on behalf of an organization, you represent that you are authorized to bind that organization.',
        'We may suspend or terminate an account for breach of these Terms, abusive use, suspected fraud, or for security or compliance reasons.',
      ],
    },
    {
      heading: '4. No professional advice',
      paragraphs: [
        'The Service provides decision-support tools and estimates based on data you enter. It is not financial, legal, tax, accounting, investment, or brokerage advice.',
        'Results (cash flow, cap rates, CMHC or conventional simulations, etc.) are indicative only. You must validate any decision with qualified professionals and applicable official sources.',
      ],
    },
    {
      heading: '5. User content and sharing',
      paragraphs: [
        'You retain your rights in data and documents you upload or enter (“User Content”). You grant us a worldwide, non-exclusive licence to host, process, display, and transmit that Content as needed to provide the Service, including when you enable sharing (link, invitation, data room, etc.).',
        'You alone are responsible for User Content, the recipients you invite, and compliance with applicable law (including third-party confidentiality, NDAs, and professional brokerage rules).',
        'Share links may be accessible without an account depending on the configuration you choose. Manage those links carefully.',
      ],
    },
    {
      heading: '6. Market data and Service improvement',
      paragraphs: [
        'By using the Service, you acknowledge that we may use data derived from your User Content, after anonymization or aggregation, to improve the Service, produce statistics and market indicators, and develop new features. Details are set out in our Privacy Policy.',
      ],
    },
    {
      heading: '7. Acceptable use',
      paragraphs: [
        'You agree not to:',
      ],
      list: [
        'use the Service unlawfully, fraudulently, or deceptively;',
        'attempt unauthorized access to systems, accounts, or others’ data;',
        'disrupt, overload, or compromise the Service;',
        'scrape or mass-copy Service content or data without written permission;',
        'use the Service to harass, defame, or infringe third-party rights;',
        'circumvent security measures or access restrictions (including modules not yet open to the public).',
      ],
    },
    {
      heading: '8. Intellectual property',
      paragraphs: [
        'The Service, its code, design, trademarks, logos, and content we provide remain our property or that of our licensors. No licence is granted beyond the personal or internal business use needed to use the Service under these Terms.',
      ],
    },
    {
      heading: '9. Availability and changes',
      paragraphs: [
        'We strive to keep the Service available but do not guarantee uninterrupted or error-free operation. Maintenance, outages, or limitations may occur.',
        'We may modify, suspend, or remove features for technical, legal, or commercial reasons. We may also update these Terms; the applicable version will be shown on the Terms of Use page. Continued use after publication may constitute acceptance of changes, subject to applicable law.',
      ],
    },
    {
      heading: '10. Limitation of liability',
      paragraphs: [
        'To the extent permitted by applicable law, the Service is provided “as is” and “as available”, without express or implied warranties (including merchantability, fitness for a particular purpose, or accuracy of calculations).',
        'To the extent permitted by law, we will not be liable for indirect, incidental, special, punitive, or consequential damages, or for loss of profits, data, or business opportunities arising from use of or inability to use the Service.',
        'Nothing in these Terms excludes liability that cannot be limited or excluded under the laws of Québec or Canada.',
      ],
    },
    {
      heading: '11. Termination',
      paragraphs: [
        'You may stop using the Service and request account deletion through available mechanisms or by contacting us. We may terminate or suspend access for breach of the Terms or other legitimate reasons.',
        'Provisions that by their nature should survive (intellectual property, limitations of liability, governing law) remain in effect after termination.',
      ],
    },
    {
      heading: '12. Governing law and disputes',
      paragraphs: [
        'These Terms are governed by the laws of the Province of Québec and the federal laws of Canada applicable therein, without regard to conflict-of-law rules. The courts of the judicial district of Montréal (Québec) have exclusive jurisdiction, subject to any mandatory consumer rights you may have.',
      ],
    },
    {
      heading: '13. Contact',
      paragraphs: [
        'For questions about these Terms: mmarceau@dmii.ca — Rentalyzer / DMII.',
      ],
    },
  ],
};
